import React from 'react';
import styled from 'styled-components';

import Checkbox from '../../../../components/Checkbox';
import CountryLabel from '../../../../components/CountryLabel';
import ListRow from '../../../../components/List/Row';
import ListHeader from '../../../../components/List/Header';
import Tooltip from '../../../../components/Tooltip';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import Icon from '../../../../components/Icon';

import { I18n } from 'react-redux-i18n';

const TasterSubscriptionListContainer = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: ${(props) => props.theme.colors.dark};
  min-width: 1300px;
  .informationContainer {
    display: flex;
    height: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    width: calc(15% - 20px);
    padding-left: 20px;
    font-family: ${(props) => props.theme.fonts.oswald};
    text-transform: uppercase;
    font-size: 12px;
    line-height: 20px;
  }
  .subscriptionItem {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .informationContainer img {
    width: 100px;
    height: 50px;
  }
  .countryContainer {
    height: 100%;
    width: 7%;
    justify-content: center;
  }
  .linkContainer {
    height: 100%;
    width: 7%;
    justify-content: center;
    text-align: center;
  }
  .linkIconContainer {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    color: #adb5bd;
  }
  .descriptionContainer {
    height: 100%;
    width: calc(33% - 20px);
    padding-left: 20px;
    font-size: 12px;
    line-height: 24px;
    justify-content: center;
    white-space: normal;
    color: ${(props) => props.theme.colors['dark-two']};
  }
  .subscriptionContainer {
    height: 100%;
    width: calc(18% + 7px);
    justify-content: center;
  }
  .checkedContainer {
    height: 100%;
    width: 7%;
    justify-content: center;
  }
  .loginContainer {
    height: 100%;
    width: calc(14% - 20px);
    display: flex;
    justify-content: center;
  }
  .tooltipContainer {
    margin-right: 10px;
  }
  .checkbox {
    opacity: 1 !important;
  }
`;

const formatCountryCode = (subscription) => {
  subscription.countryName = subscription.country_origin.code;
  return subscription.countryName;
};

const formatSelectOptions = (apiOptions) =>
  apiOptions.map((option) => ({ value: option.id, label: option.name }));

const TasterSubscriptionList = ({
  data,
  handleCheckbox,
  handleLogin,
  handleSelectChange,
  sortColumn
}) => (
  <TasterSubscriptionListContainer>
    <ListHeader
      columns={[
        {
          length: 'calc(15%)',
          name: I18n.t('tasterSubscription.columns.taster'),
          sort: true,
          onSort: () => sortColumn('name')
        },
        {
          name: I18n.t('tasterSubscription.columns.origin'),
          length: '7%',
          sort: true,
          onSort: () => sortColumn('countryName'),
          center: true
        },
        {
          name: I18n.t('tasterSubscription.columns.link'),
          length: '7%',
          center: true
        },
        {
          name: I18n.t('tasterSubscription.columns.subscribed'),
          length: '7%',
          sort: true,
          onSort: () => sortColumn('data'),
          center: true
        },
        {
          name: I18n.t('tasterSubscription.columns.subscription'),
          length: '18%',
          center: true
        },
        {
          name: I18n.t('tasterSubscription.columns.login'),
          length: '14%',
          center: true
        },
        {
          name: I18n.t('tasterSubscription.columns.description'),
          length: '33%'
        }
      ]}
    />
    {data.map((subscription, index) => (
      <ListRow
        dark={index % 2 === 0}
        key={`subscriptionRow + ${index}`}
        height="auto"
        padding="10px 0"
      >
        <div className="informationContainer">
          <div className="logoContainer">
            {subscription.image ? (
              <img src={subscription.image} alt={subscription.name} />
            ) : (
              <p>{subscription.name}</p>
            )}
          </div>
        </div>
        <div className="countryContainer">
          {subscription.country_origin ? (
            <CountryLabel
              styleFlag={{ fontSize: 16 }}
              name={formatCountryCode(subscription)}
            />
          ) : (
            <p> - </p>
          )}
        </div>
        <div className="linkContainer">
          <a
            target="_blank"
            href={subscription.url_subscription}
            rel="noreferrer"
          >
            <div className="linkIconContainer">
              <Icon icon="linkContainer" />
            </div>
          </a>
        </div>

        <div className="checkedContainer">
          <Checkbox
            className="checkbox"
            checked={subscription.data}
            onChange={() => handleCheckbox(subscription.id)}
          />
        </div>
        <div className="subscriptionContainer">
          <div className="subscriptionItem">
            <div className="tooltipContainer">
              <Tooltip
                placement="top"
                content={
                  <p style={{ padding: 10 }}>
                    {subscription.description_subscription
                      ? subscription.description_subscription
                      : 'Aucune information complémentaire'}
                  </p>
                }
              />
            </div>
            <Select
              dropdownProps={{ styles: `margin-left:-25px` }}
              options={formatSelectOptions(
                subscription.subscription_types || []
              )}
              value={
                subscription.data &&
                formatSelectOptions(subscription.subscription_types || []).find(
                  (item) => item.value === subscription.data.subscription_type
                )
              }
              onChange={(selectedOption) =>
                subscription.data &&
                handleSelectChange(subscription.id, selectedOption)
              }
            />
          </div>
        </div>

        <div className="loginContainer">
          <Input
            value={subscription.data && subscription.data.login}
            onChange={(value) =>
              subscription.data && handleLogin(subscription.id, value)
            }
          />
        </div>
        <div className="descriptionContainer">
          <p>{subscription.description ? subscription.description : '-'}</p>
        </div>
      </ListRow>
    ))}
  </TasterSubscriptionListContainer>
);

export default TasterSubscriptionList;
